import { Skeleton, SkeletonText } from "@chakra-ui/react";

function MovieCardSkeleton() {
  return (
    <>
      <Skeleton
        sx={{
          height: "27rem",
          borderRadius: "lg",
        }}
      ></Skeleton>
      <SkeletonText mt="1rem" noOfLines={2} skeletonHeight="1rem" />
    </>
  );
}

export default MovieCardSkeleton;
